import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { classNames } from '~/utils';

interface DropdownMenuButtonItemProps extends RadixDropdownMenu.DropdownMenuItemProps {
  highlighted?: boolean;
}

export const DropdownMenuButtonItem = forwardRef<HTMLDivElement, DropdownMenuButtonItemProps>(
  ({ className, children, highlighted, disabled, onClick, onSelect, ...props }, forwardedRef) => {
    const classes = classNames(
      'body-200-light w-full px-4 py-[6px] text-left text-neutral-1000 hover:bg-neutral-200 focus:bg-teal-200 focus:text-teal-700',
      { 'bg-teal-200 hover:bg-teal-200': highlighted, 'text-neutral-600': disabled },
      className,
    );

    return (
      // Keyboard focus lands on the item, not the inner button, so the highlight must live here.
      // `aria-disabled` keeps it arrow-key reachable; Radix turns Enter into a click, hence both guards.
      <RadixDropdownMenu.Item
        aria-disabled={disabled}
        className="focus-visible:outline-hidden data-highlighted:bg-neutral-200"
        ref={forwardedRef}
        onClick={disabled ? undefined : onClick}
        onSelect={(event) => {
          if (disabled) {
            event.preventDefault();
            return;
          }
          onSelect?.(event);
        }}
        {...props}
      >
        <button className={classes} disabled={disabled} type="button">
          {children}
        </button>
      </RadixDropdownMenu.Item>
    );
  },
);
